import React from 'react';
import { Modal } from 'app/components';

const DeleteModal = ({ onCancel, onConfirm, isOpen }) => {
  return (
      <Modal
        isOpen={isOpen}
        size="regular"
        primaryText="Delete"
        secondaryText="Cancel"
        onClickPrimaryCta={onConfirm}
        onClickSecondaryCta={onCancel}
        className='delete-modal'
      >
        <div className="heading-24">
          Are you sure you want to delete this event?
        </div>
      </Modal>
  );
};

export default DeleteModal;
